import create from "zustand";

import { storageSession as session } from "../../../../../../utils/StorageHandler";
import createFormErrorSlices from "../../../../../../utils/store/formErrors";

interface iHeatingOilVoucher {
    voucher: string;
    name: string;
    value: number;
    setData: (voucher: string, name: string, value: number) => void;
}

const useStore = create<iHeatingOilVoucher>((set, get) => ({
    ...createFormErrorSlices(set, get),
    voucher: session.get("hel:voucher:code", ""),
    name: session.get("hel:voucher:name", ""),
    value: session.get("hel:voucher:value", ""),
    setData: (voucher, name, value) => {
        set({ voucher, name, value });
        session.set("hel:voucher:code", voucher);
        session.set("hel:voucher:name", name);
        session.set("hel:voucher:value", value);
    },
    reset: () => {
        set({
            voucher: "",
            name: "",
            value: -1,
        });
        session.set("hel:voucher:code", "");
        session.set("hel:voucher:name", "");
        session.set("hel:voucher:value", -1);
    },
}));

export default useStore;
